import { render, staticRenderFns } from "./ryujinx.vue?vue&type=template&id=677aad15&"
import script from "./ryujinx.vue?vue&type=script&lang=ts&"
export * from "./ryujinx.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports